import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import IntegerSelector from '../fields/number/IntegerSelector';
import GlobalFilterPanel, { FILTER_PERIOD_GROUP } from '../filter/GlobalFilterPanel';
import StaticApplicationMessage from '../inAppMessages/StaticApplicationMessage';

const log = new Logger('TRANSACTION_SEARCH_FILTER_PANEL', LOG_LEVELS.DEBUG);

const showExactMatchControl = false;

class TransactionSearchFilterPanel extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      selection: {}
    };
    this.onSearchClick = this.onSearchClick.bind(this);
    this.updateFilterValues = this.updateFilterValues.bind(this);
  }

  onSearchClick(selection) {
    let combinedSelection = Object.assign({}, this.state.selection, selection);
    this.props.doSearchIDsAndFirstPage(combinedSelection);
  }

  exactMatchInputHandler(evt) {
    let selection = Object.assign({}, this.state.selection);
    selection.exactMatch = (evt.target.checked || selection.searchType ===  '1') ? '1': '0';
    log.debug('exactMatchInputHandler: ', selection);
    this.setState({selection: selection});
  }

  searchTypeInputHandler(evt) {
    let selection = Object.assign({}, this.state.selection, {searchType: evt.target.value});
    if (selection.searchType === '1') {
      selection.exactMatch = '1';
    } 
    log.debug('searchTypeInputHandler: ', selection);
    this.setState({selection: selection});
  }

  genericInputHandlerFactory(fieldName) {
    return (evt) => {
      let selection = Object.assign({}, this.state.selection);
      selection[fieldName] = evt.target.value === '' ? undefined : evt.target.value;
      log.debug('genericInputHandlerFactory: ', selection);
      this.setState({selection: selection});
    };
  }

  keyValuePairHandler(keyValuePairs) {
    log.debug('selectionHandler(): keyValuePairs: ', keyValuePairs);
    let key =  Object.keys(keyValuePairs)[0];
    let value =  Object.values(keyValuePairs)[0];
    let selection = Object.assign({}, this.state.selection);
    if(_.isEmpty(value)) {
      delete selection[key];
    } else {
      selection = Object.assign(selection, keyValuePairs);
    }
    this.setState({
      selection: selection
    });
  }

  updateFilterValues(filterOptions={}) {
    if(_.isEmpty(filterOptions)) {
      return;
    }
    let selection = {
      searchType: filterOptions.searchType,
      exactMatch: filterOptions.exactMatch,
      reference: filterOptions.reference
    };
    this.setState({
      selection: selection
    });
  }

  componentDidUpdate(prevProps) {
    if(this.props.filterOptions !== prevProps.filterOptions) {
      this.updateFilterValues(this.props.filterOptions);
    }
  }

  componentDidMount() {
    this.updateFilterValues(this.props.filterOptions);
  }

  render() {
    log.debug('render: ', this.props);
    const selection = this.state.selection || {};
    const disableSearch = !selection.reference;
    const disableCompany = selection.searchType === '1';
    const disableYear = selection.searchType === '1';
    // Show banner when Invoice ID (Default) , Own Reference , Supplier Invoice Number is selected, Document ID is not selected or when searchType is undefined/not set
    const showBanner = ['0', '2', '3', undefined].includes(selection.searchType);
    return (
      <s-box name="filter-panel">
        {showBanner && (
          <StaticApplicationMessage
            messageType="applicationInfo"
            string="transactionSearchFilterPanel_FiscalYearBanner"
            languages={this.props.languages}
            nodismiss={true}
          />
        )}
        <GlobalFilterPanel 
          filterPeriodGroup={FILTER_PERIOD_GROUP.MONTH_YEAR} 
          hideElements={{
            startDate: true,
            endDate: true,
            month: true,
            countryCode: true,
            returnType: true,
            returnStatus: true
          }}
          disableElements={
            {
              companyId: disableCompany,
              year: disableYear
            }
          }
          labelElements={{
            year: 'transactionSearchFilterPanel_FiscalYearLabel'
          }}
          atLeastOneRequired={false}
          disableSearch={disableSearch} 
          onSearchClick={this.onSearchClick}
        >
          <fieldset>
            <legend><LanguageStringResolver string="transactionSearchFilterPanel_referenceType"/></legend>
            <span className="clear"></span>
            <input
                type="radio"
                onChange={this.searchTypeInputHandler.bind(this)}
                name="type"
                value="0"
                checked={selection.searchType==="0"}
              />
            <label className="radio"><LanguageStringResolver string="transactionSearchFilterPanel_InvoiceNumberLabel"/></label>
            <input
                type="radio"
                onChange={this.searchTypeInputHandler.bind(this)}
                name="type"
                value="1"
                checked={selection.searchType==="1" || selection.searchType===undefined}
              />
            <label className="radio"><LanguageStringResolver string="transactionSearchFilterPanel_DocumentIDLabel"/></label>
            <input
                type="radio"
                onChange={this.searchTypeInputHandler.bind(this)}
                name="type"
                value="2"
                checked={selection.searchType==="2"}
              />
            <label className="radio"><LanguageStringResolver string="transactionSearchFilterPanel_OwnReferenceLabel"/></label>
            <input
                type="radio"
                onChange={this.searchTypeInputHandler.bind(this)}
                name="type"
                value="3"
                checked={selection.searchType==="3"}
              />
            <label className="radio"><LanguageStringResolver string="transactionSearchFilterPanel_SupplierInvoiceNumberLabel"/></label>
          </fieldset>
          <fieldset>
            <label><LanguageStringResolver string="transactionSearchFilterPanel_document"/></label>
            <input 
              type="text" 
              onChange={this.genericInputHandlerFactory('reference').bind(this)}
              name="documentSearch" 
              value={selection.reference}
            />
          </fieldset>
          { (showExactMatchControl) ? (
            <fieldset>
              <legend><LanguageStringResolver string="transactionSearchFilterPanel_ExactMatchLabel"/></legend>
              <span className="clear"></span>
              <input
                type="checkBox"
                onChange={this.exactMatchInputHandler.bind(this)}
                name="exactMatch"
                checked={selection.exactMatch === '1'}
              />
              <label className="checkbox"><LanguageStringResolver string="transactionSearchFilterPanel_ExactMatchLabel_true"/></label>
            </fieldset>
          ): (<div></div>)}
        </GlobalFilterPanel>
        <div className="clear"></div>
      </s-box>
    )
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages && state.languages.data
  };
}


TransactionSearchFilterPanel.defaultProps = {
  doSearchIDsAndFirstPage: ()=>{},
  filterOptions: {}
}

// Wrap the component to inject state into it
export default connect(mapStateToProps)(TransactionSearchFilterPanel);
